// extracted by mini-css-extract-plugin
export default {"commentActions":"Jw7dGMPC7IpaOMcteJcT","likesCount":"LUSE2p0kKB_blZouDi2A","likesCountLiked":"A8cd4y2FMeBkZZK0lTKH"};